import { createAction } from '@reduxjs/toolkit';

export const sendPaymentMethodAnalytics = createAction(
  `paymentAnalytics/methodsIncludedAnalytics`,
);
